import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserContext } from '../../providers/UserProvider';
import { Spinner } from 'react-bootstrap';

const Root = () => {
  const { isLoading, user, selectedTenant, selectedWarehouse } =
    useUserContext();

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (user) {
    const tenant = selectedTenant?.domains?.[0]?.domain;
    const warehouse = selectedWarehouse?.domain;

    if (tenant && warehouse) {
      return <Navigate to={`/${tenant}/${warehouse}`} replace />;
    }
    // If user exists but tenant/warehouse somehow not, this is an error state.
    // For now, redirecting to login is a safe fallback.
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/login" replace />;
};

export default Root;
